import type { Recipe } from '../../domain/recipe';
import { ASIAN_RECIPES } from './asian';
import { BREAKFAST_RECIPES } from './breakfasts';
import { GERMAN_RECIPES } from './german';
import { ITALIAN_RECIPES } from './italian';
import { UKRAINIAN_RECIPES } from './ukrainian';

// DE: Alle eingebauten Rezepte; eigene Rezepte werden später angehängt.
// EN: All built-in recipes; own recipes are appended later.
export const RECIPES: readonly Recipe[] = [
  ...ASIAN_RECIPES,
  ...UKRAINIAN_RECIPES,
  ...ITALIAN_RECIPES,
  ...GERMAN_RECIPES,
  ...BREAKFAST_RECIPES,
];
